import * as React from 'react';
import { CarouselContext } from './Carousel';

export const useCarousel = () => {
  const { slidingIndex, slidesCount, slidesToMove, slidesToShow, wrapperWidth, setSlidingIndex, centered } =
    React.useContext(CarouselContext);
  const nextSlide = () =>
    setSlidingIndex((slidingIndex) => Math.round(Math.min(slidingIndex + slidesToMove, slidesCount - slidesToShow)));
  const prevSlide = () => setSlidingIndex((slidingIndex) => Math.round(Math.max(0, slidingIndex - slidesToMove)));

  return {
    setSlidingIndex,
    slidingIndex,
    slidesCount,
    slidesToShow,
    wrapperWidth,
    nextSlide,
    prevSlide,
    centered,
  };
};
